import { icons, type IconKey } from "./icons";

interface IconProps {
  name: IconKey;
  /** px size applied to both width and height. The design system uses 16, 18 and 20. */
  size?: number;
  className?: string;
  /** Accessible label. Omit for decorative icons (rendered aria-hidden). */
  label?: string;
}

/**
 * The single way the app renders icons: <Icon name="close" />.
 * Stroke is 2px at every size (`absoluteStrokeWidth`), as drawn in the Figma frames.
 */
export function Icon({ name, size = 20, className, label }: IconProps) {
  const Glyph = icons[name];
  return (
    <Glyph
      width={size}
      height={size}
      strokeWidth={2}
      absoluteStrokeWidth
      className={className}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
